<template>
  <svg id="vloeren" viewBox="0 0 64 64">
    <path
      d="M53.7,24.2h6.5v6.5h-6.5V24.2z M45.2,24.2h6.5v6.5h-6.5V24.2z M51.7,22.2h-6.5v-6.5h6.5V22.2z M60.3,22.2h-6.5
                v-6.5h6.5V22.2z M43.1,32.8h19.2V13.6H43.1V32.8z"
    />
    <polygon
      points="35.4,38.8 29.6,44.1 29.6,17.8 27.5,17.8 27.5,44.1 21.7,38.8 20.3,40.4 28.5,47.8 36.8,40.4"
    />
    <polygon
      points="11.8,5 11.8,57 0,57 0,59.1 64,59.1 64,57 13.8,57 13.8,54.5 64,54.5 64,52.4 13.8,52.4 13.8,7.1
                63.1,7.1 63.1,5"
    />
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IconVloeren extends Vue {}
</script>
